import { forwardRef, type ComponentProps } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'

export interface ComboboxChipsProps extends ComponentProps<typeof Combobox.Chips> {
  className?: string
}

const ComboboxChips = forwardRef<HTMLDivElement, ComboboxChipsProps>(({ className, ...props }, ref) => {
  return (
    <Combobox.Chips
      ref={ref}
      className={twMerge(
        'border-border hover:border-hover focus-within:bg-element text-foreground placeholder:text-foreground-placeholder corner-smooth relative flex min-h-11 w-full flex-wrap items-center gap-x-2 gap-y-2 rounded-2xl border bg-transparent p-2 text-sm outline-none transition-colors focus-within:border-[color:var(--focus-ring-color)]',
        className,
      )}
      {...props}
    />
  )
})
ComboboxChips.displayName = 'ComboboxChips'

export { ComboboxChips }
